<template>
  <div class="sh-tabs-panel" v-show="name === activeName">
    <slot />
  </div>
</template>

<script>
import { inject } from "vue";
export default {
  name: "ShTabsPanel",
  props: {
    //选项卡文字 $slot.default() 可以拿到默认插槽内容
    label: {
      type: String,
      default: "",
    },
    //选项卡唯一标识
    name: {
      type: [String, Number],
      default: "",
    },
  },
  setup() {
    const activeName = inject("activeName");
    return { activeName };
  },
};
</script>

<style lang="less" scoped></style>
